/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useContext, useEffect, useState } from 'react';
import {  useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { compose } from 'recompose';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';
import ReactMarkdown from 'react-markdown';
import {
    shape, number, string, bool, func, arrayOf,
} from 'prop-types';
import CUSTOM_BREAKPOINTS from '../../../../../helpers/customBreakpoints';
import { setBrandMovieSkus } from '../../../../../../state/ducks/App/App-Actions';
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { trackData, trackPage } from '../../../../../helpers/tracking/common/commonTrackingHelpers';
import MoreMoviesModal from './Partials/MoreMoviesModal';
import { CrossMerch } from '../../../CrossMerchContainer/CrossMerchContainer';

const useStyles = makeStyles((theme) => ({
    headerTextContainer: {
        width: '80%',
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            paddingLeft: '15px',
        },
    },
    imageContainer: {
        width: '7%',
        padding: 3,
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
        },
    },
    headerText: {
        fontSize: '14px',
        textAlign: 'center',
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            textAlign: 'start',
            marginLeft: '5%',
        },
    },
    outerContainer: {
        paddingLeft: '12px',
    },
    skuDescription: {
        fontSize: '12px',
    },
    andMore: {
        fontSize: '12px',
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        textDecoration: 'underline',
        fontWeight: 'bold',
        cursor: 'pointer',
    },
    skuDescriptionContainer: {
        width: '80%',
        marginTop: 2,
        lineHeight: 1.2,
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            width: '76%',
        },
    },
    skuPrice: {
        fontWeight: 'bold',
        fontSize: '14px',
    },
    outerPaper: {
        clear: 'both',
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            marginBottom: '10px',
        },
    },
    linkText: {
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        textDecoration: 'underline',
        fontSize: '12px',
    },
    linkContainer: {
        textAlign: 'right',
        marginRight: '10px',
    },
    iconImage: {
        width: '100%',
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            width: '200%',
        },
    },
    skuInfoContainer: {
        '& svg': {
            width: 24,
        },
        '& label': {
            marginRight: 4,
            '&>span:first-child': {
                padding: '0px 20px',
                [theme.breakpoints.down('xs')]: {
                    padding: '0 17px 0 8px',
                },
            },
        },
        '& fieldset': {
            width: '100%',
        },
    },
    flex: {
        display: 'flex',
    },
    imageMainContainer: {
        marginLeft: '36px',
        [theme.breakpoints.down('400')]: {
            marginLeft: '20px',
        },
    },
}));

const NBCUMovieBanner = ({
    skuData,
    movieSelected,
    selectMovieSku,
    isStandAloneMovieSku,
}) => {
    const { featureFlags = {} } = useContext(CrossMerch);
    if (!featureFlags['is-nbcu-movie-flow-enabled']
        || isStandAloneMovieSku
        || !skuData
    ) {
        return null;
    }

    trackData({
        modalData: skuData,
        movieSelected,
        selectMovieSku,
        action: 'track_NBCU_data',
    });

    const classes = useStyles();
    const dispatch = useDispatch();
    const [modalData, changeModalState] = useState(false);
    useEffect(() => {
        const movieSkus = {};
        skuData.products.forEach((product) => {
            movieSkus[product.sku] = true;
        });
        dispatch(setBrandMovieSkus(movieSkus));
    }, []);
    const movieCheckboxOnChange = (e) => {
        if (!movieSelected.skuSelected) {
            selectMovieSku({ skuSelected: skuData?.products?.find((product) => product.sku === e.target.name), error: false });
            dispatch(trackEvent({
                eventCategory: 'Product Page',
                eventAction: 'NBCU Option',
                eventLabel: e.target.name[e.target.name.length - 1] === 'A' ? 'large' : 'small',
            }));
        } else if (movieSelected.skuSelected.sku === e.target.name) {
            selectMovieSku({});
        } else if (movieSelected.skuSelected && movieSelected.skuSelected.sku !== e.target.name) {
            selectMovieSku({ ...movieSelected, error: true });
        }
    };
    return (
        <Paper elevation={3} className={classes.outerPaper}>
            <Grid direction="column" className={classes.outerContainer}>
                <Grid item container className={classes.imageMainContainer}>
                    <Grid item className={classes.imageContainer}>
                        <img className={classes.iconImage} src={skuData?.icon?.url} alt={skuData?.icon?.title} />
                    </Grid>
                    <Grid item className={classes.headerTextContainer}>
                        <Grid className={classes.headerText}>
                            <ReactMarkdown source={skuData?.title} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item className={classes.skuInfoContainer}>
                    <FormControl className={classes.flex} component="fieldset" error={movieSelected.error}>
                        <FormGroup>
                            {skuData?.products?.map((product) => (
                                <Grid container key={product.sku}>
                                    <Grid item>
                                        <FormControlLabel label={<Typography className={classes.skuPrice}>{product.sku_price}</Typography>} control={<Checkbox onChange={movieCheckboxOnChange} checked={movieSelected.skuSelected?.sku === product.sku} name={product.sku} />} />
                                    </Grid>
                                    <Grid item className={classes.skuDescriptionContainer}>
                                        <ReactMarkdown renderers={{ root: 'span', paragraph: 'span' }} source={product.sku_description} className={classes.skuDescription} />
                                        <span>. </span>
                                        <span onClick={() => { changeModalState(product.more_movies); }} onKeyDown={() => {}} className={classes.andMore} role="presentation">See titles.</span>
                                    </Grid>
                                </Grid>
                            ))}
                        </FormGroup>
                        {movieSelected.error && <FormHelperText>Please select only one option</FormHelperText>}
                    </FormControl>
                    <Grid className={classes.linkContainer}>
                        <Link to="/nbc-universal">
                            <Typography className={classes.linkText}>
                                Learn more &gt;
                            </Typography>
                        </Link>
                    </Grid>
                </Grid>
            </Grid>
            <MoreMoviesModal modalData={modalData} changeModalState={changeModalState}  />
        </Paper>
    );
};

NBCUMovieBanner.propTypes = {
    isStandAloneMovieSku: bool,

    movieSelected: shape({
        error: bool,
        skuSelected: shape({
            sku: string.isRequired,
            sku_description: string.isRequired,
            sku_price: number.isRequired,
        }),
    }).isRequired,
    selectMovieSku: func.isRequired,
    skuData: shape({
        icon: shape({
            content_type: string,
            file_size: string,
            filename: string,
            is_dir: bool,
            title: string.isRequired,
            uid: string,
            url: string.isRequired,
        }).isRequired,
        products: arrayOf(
            shape({
                sku: string.isRequired,
                sku_description: string.isRequired,
                sku_price: number.isRequired,
            }).isRequired,
        ).isRequired,
    }).isRequired,
};

NBCUMovieBanner.defaultProps = {
    isStandAloneMovieSku: false,
};

const enhance = compose(
    trackPage(),
);

export default enhance(NBCUMovieBanner);
